import { useEffect } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ClaimHandler from "./components/ClaimHandler";
import ConsentBanner from "./components/ConsentBanner";
import { envVar } from "./config";
import { initAnalytics, trackPageview } from "./analytics";
import "./App.css";
import AppRoutes from "./AppRoutes";

/** Loads tags if consent was already granted, then sends a token-free page_view per route. */
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    initAnalytics();
  }, []);
  useEffect(() => {
    trackPageview(location.pathname);
  }, [location.pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <Auth0Provider
      domain={envVar("REACT_APP_AUTH0_DOMAIN", "your-tenant.us.auth0.com")}
      clientId={envVar("REACT_APP_AUTH0_CLIENT_ID", "your-client-id")}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: envVar("REACT_APP_AUTH0_AUDIENCE", "wiski-template-api"),
        scope: "openid profile email",
      }}
    >
      <Router>
        <AnalyticsTracker />
        <div className="relative min-h-screen bg-paper">
          {/* Subtle film-grain texture over the whole app. */}
          <div
            aria-hidden
            className="pointer-events-none fixed inset-0 z-0 bg-grain opacity-[0.05] mix-blend-multiply"
          />
          <ClaimHandler />
          <div className="relative z-10 flex min-h-screen flex-col">
            <Navbar />
            <main className="container mx-auto w-full max-w-5xl flex-1 px-4 py-8">
              <AppRoutes />
            </main>
            <Footer />
          </div>
          <ConsentBanner />
        </div>
      </Router>
    </Auth0Provider>
  );
};

export default App;
